import avatarFemale1 from './avatar_female_1.png'
import avatarFemale2 from './avatar_female_2.png'
import avatarFemale3 from './avatar_female_3.png'
import avatarFemale4 from './avatar_female_4.png'
import avatarFemale5 from './avatar_female_5.png'
import avatarFemale6 from './avatar_female_6.png'
import avatarFemale7 from './avatar_female_7.png'
import avatarFemale8 from './avatar_female_8.png'
import avatarFemale9 from './avatar_female_9.png'
import avatarFemale10 from './avatar_female_10.png'
import avatarFemale11 from './avatar_female_11.png'
import avatarFemale12 from './avatar_female_12.png'

import avatarMale1 from './avatar_male_1.png'
import avatarMale2 from './avatar_male_2.png'
import avatarMale3 from './avatar_male_3.png'
import avatarMale4 from './avatar_male_4.png'
import avatarMale5 from './avatar_male_5.png'
import avatarMale6 from './avatar_male_6.png'
import avatarMale7 from './avatar_male_7.png'
import avatarMale8 from './avatar_male_8.png'
import avatarMale9 from './avatar_male_9.png'
import avatarMale10 from './avatar_male_10.png'
import avatarMale11 from './avatar_male_11.png'
import avatarMale12 from './avatar_male_12.png'
import avatarMale13 from './avatar_male_13.png'

export const FEMALE_AVATARS = [
    avatarFemale1,
    avatarFemale2,
    avatarFemale3,
    avatarFemale4,
    avatarFemale5,
    avatarFemale6,
    avatarFemale7,
    avatarFemale8,
    avatarFemale9,
    avatarFemale10,
    avatarFemale11,
    avatarFemale12,
]

export const MALE_AVATARS = [
    avatarMale1,
    avatarMale2,
    avatarMale3,
    avatarMale4,
    avatarMale5,
    avatarMale6,
    avatarMale7,
    avatarMale8,
    avatarMale9,
    avatarMale10,
    avatarMale11,
    avatarMale12,
    avatarMale13,
]

const buildAvatarOptions = (sources, gender, prefix) =>
    sources.map((src, index) => ({
        id: `${prefix}_${index + 1}`,
        src,
        gender,
    }))

/** All bundled default avatars with stable ids for create/edit client flows */
export const DEFAULT_AVATAR_OPTIONS = [
    ...buildAvatarOptions(FEMALE_AVATARS, 'Female', 'avatar_female'),
    ...buildAvatarOptions(MALE_AVATARS, 'Male', 'avatar_male'),
]

export const getDefaultAvatarsForGender = (gender) => {
    const g = (gender || '').toString().trim().toLowerCase()
    if (g === 'male' || g === 'm') {
        return DEFAULT_AVATAR_OPTIONS.filter((o) => o.gender === 'Male')
    }
    if (g === 'female' || g === 'f') {
        return DEFAULT_AVATAR_OPTIONS.filter((o) => o.gender === 'Female')
    }
    return DEFAULT_AVATAR_OPTIONS
}

export const findDefaultAvatarOptionById = (id) =>
    DEFAULT_AVATAR_OPTIONS.find((o) => o.id === id)

export const findDefaultAvatarOptionBySrc = (src) => {
    if (!src || typeof src !== 'string') return undefined
    const normalized = src.trim()
    return DEFAULT_AVATAR_OPTIONS.find((o) => o.src === normalized)
}

const hashString = (str) => {
    const safe = typeof str === 'string' ? str : String(str ?? '')
    let hash = 0
    for (let i = 0; i < safe.length; i++) {
        hash = safe.charCodeAt(i) + ((hash << 5) - hash)
    }
    return Math.abs(hash)
}

const normalizeGender = (gender) => {
    const g = (gender || '').toString().trim().toLowerCase()
    if (g === 'female' || g === 'f') return 'female'
    if (g === 'male' || g === 'm') return 'male'
    return 'unknown'
}

export function getRandomAvatar({ gender, seed } = {}) {
    const g = normalizeGender(gender)
    const pool =
        g === 'female'
            ? FEMALE_AVATARS
            : g === 'male'
              ? MALE_AVATARS
              : [...FEMALE_AVATARS, ...MALE_AVATARS]

    if (!pool.length) return undefined
    const idx = hashString(seed ?? gender ?? 'avatar') % pool.length
    return pool[idx]
}
